@import '~style-sheet-helpers/core.less';

.shipment-action,
.shipment-action button {
  min-height: 26px;
  line-height: 24px;
  font-size: 12px;
}
